import * as React from "react";
import { useTranslation } from "react-i18next";
import { Activity } from "../../models/interfaces/profile-summary.interface";
import ProfileUserActivities from "../../presentations/ProfileUserActivities";

const ProfileUserActivitiesContainer = () => {
  const { t } = useTranslation();

  const data: Activity[] = [
    {
      activityType: "Profile Settings",
      summary: "status changed to active",
      updatedOn: new Date(),
    },
    {
      activityType: "Profile Settings",
      summary: "status changed to active",
      updatedOn: new Date(),
    },
    {
      activityType: "Profile Settings",
      summary: "status changed to active",
      updatedOn: new Date(),
    },
  ];

  return (
    <div className="p-4 bg-gray-50">
      <div className="mb-4 font-semibold text-gray-700">
        {t("profileSummary.label.userActivities")}
      </div>
      <div>
        <ProfileUserActivities activities={data}></ProfileUserActivities>
      </div>
    </div>
  );
};

export default ProfileUserActivitiesContainer;
